import { updateElements } from "./updateElements";

const handleButtonClick = (button: HTMLElement) => {
  const originalText = button.textContent;

  const buttonObserver = new MutationObserver(() => {
    if (button.textContent !== originalText) {
      buttonObserver.disconnect();
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer?.renderContents) {
        updateElements([".drawer__inner", ".cart-count-bubble"]);
        cartDrawer.renderContents();
        cartDrawer.classList.remove("is-empty");
      }
    }
  });

  buttonObserver.observe(button, { attributes: true });
};

const findAndHandleButtons = () => {
  const buttons: NodeListOf<HTMLElement> = document.querySelectorAll(
    ".swym-add-to-cart-btn",
  );
  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener("click", () => handleButtonClick(button));
    });
    return true;
  }
  return false;
};

const handleWishlistAddToCart = () => {
  const mainObserver = new MutationObserver((mutations, observer) => {
    const hasFoundButtons = findAndHandleButtons();

    if (hasFoundButtons) {
      observer.disconnect();
    }
  });

  mainObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

handleWishlistAddToCart();
